export default __webpack_public_path__ + "static/media/MySQL.d0c6e8d4.svg";